import {
  IsOptional,
  IsString,
  IsEnum,
  IsUUID,
  IsObject,
  IsArray,
  MaxLength,
  ValidateNested,
} from 'class-validator'
import { Type } from 'class-transformer'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import { ResourceType } from '../../../types/resource.types'
import {
  PedagogicContentState,
  ContentVisibility,
} from '../../../enums/content.enum'
import {
  MAX_RESOURCE_TITLE_LENGTH,
  MAX_RESOURCE_DESCRIPTION_LENGTH,
  MAX_URL_LENGTH,
} from '../../../constants/resource.constants'
import {
  toStringOrUndefined,
  parseJsonOrDefault,
} from '../../../utils/transformers.util'
import { CreateResourceLinkDto } from '../../resources-link/request/create-resource-link.dto'

/**
 * DTO for updating an existing resource
 */
export class UpdateResourceDto {
  @ApiPropertyOptional({
    description: 'Titre de la ressource',
    example: 'Chapitre 1 - Introduction aux mathématiques (révisé)',
    maxLength: MAX_RESOURCE_TITLE_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_RESOURCE_TITLE_LENGTH)
  @Transform(toStringOrUndefined)
  title?: string

  @ApiPropertyOptional({
    description: 'Description de la ressource',
    maxLength: MAX_RESOURCE_DESCRIPTION_LENGTH,
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_RESOURCE_DESCRIPTION_LENGTH)
  @Transform(toStringOrUndefined)
  description?: string

  @ApiPropertyOptional({
    description: 'URL de la ressource',
    maxLength: MAX_URL_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_URL_LENGTH)
  @Transform(toStringOrUndefined)
  url?: string

  @ApiPropertyOptional({
    description: 'Type de ressource',
    enum: ResourceType,
  })
  @IsOptional()
  @IsEnum(ResourceType)
  type?: ResourceType

  @ApiPropertyOptional({
    description: 'ID de la leçon associée (rétrocompatibilité, préférer links)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  @Transform(toStringOrUndefined)
  lessonId?: string

  @ApiPropertyOptional({
    description: 'ID du chapitre associé (rétrocompatibilité, préférer links)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  @Transform(toStringOrUndefined)
  chapterId?: string

  @ApiPropertyOptional({
    description: 'Liens vers plusieurs chapitres et/ou leçons (remplace les liens existants)',
    type: () => [CreateResourceLinkDto],
  })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CreateResourceLinkDto)
  links?: CreateResourceLinkDto[]

  @ApiPropertyOptional({
    description: 'Métadonnées de la ressource (JSON)',
  })
  @IsOptional()
  @IsObject()
  @Transform(parseJsonOrDefault)
  metadata?: Record<string, any>

  @ApiPropertyOptional({
    description: 'État de la ressource',
    enum: PedagogicContentState,
  })
  @IsOptional()
  @IsEnum(PedagogicContentState)
  state?: PedagogicContentState

  @ApiPropertyOptional({
    description: 'Visibilité de la ressource',
    enum: ContentVisibility,
  })
  @IsOptional()
  @IsEnum(ContentVisibility)
  visibility?: ContentVisibility
}
